import { useDebounce } from '../../../shared/hooks/useDebounce';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { dashboardActions } from '../../../store/slices/dashboardSlice/dashboardSlice';
import { useTranslation } from 'react-i18next';

interface daDataItem {
    full_name: string;
    inn: string;
    kpp: string;
    legal_address: string;
    ogrn: string;
    ogrnip: string;
    okpo: string;
    name?: string;
}

interface NotFound {
    isNotFound: true;
    message: string;
}

interface BicSearch {
    bic: string;
    correspondent_account: string;
    name: string;
}

export const useDaData = (onChange: (name: string, value: string) => void, inputName: string) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [companyList, setCompanyList] = useState<daDataItem[] | NotFound[]>([]);
    const fetchDaData = async (name: string, value: string) => {
        await dispatch(dashboardActions.onCustomerModalLoader(true));
        //@ts-ignore
        const url = routable.getRoute('dadataLoadRequisites');
        const response = await fetch(
            `${url}?field=${name === 'full_name' ? 'full-name' : name}&value=${value}`,
            {
                method: 'GET',
            }
        );

        const { data } = await response.json();

        if (!!data.length) {
            setCompanyList(data);
        } else {
            setCompanyList([{ isNotFound: true, message: t('useDaData.notFound.text') }]);
        }

        await dispatch(dashboardActions.onCustomerModalLoader(false));
    };

    const onDaData = useCallback((company: daDataItem | BicSearch) => {
        if (inputName === 'bik') {
            //@ts-ignore
            onChange('bik', company.bic);
            //@ts-ignore
            onChange('bank', company.name);
            //@ts-ignore
            onChange('correspondent_account_number', company.correspondent_account);
        } else {
            //@ts-ignore
            onChange('full_name', company.full_name);
            //@ts-ignore
            onChange('inn', company.inn);
            //@ts-ignore
            onChange('kpp', company.kpp);
            //@ts-ignore
            onChange('ogrn', company.ogrn);
            //@ts-ignore
            onChange('ogrnip', company.ogrnip);
            //@ts-ignore
            onChange('okpo', company.okpo);
            //@ts-ignore
            onChange('legal_address', company.legal_address);
        }
        setCompanyList([]);
    }, []);

    useEffect(() => {
        const onClose = () => {
            setCompanyList([]);
        };
        document.addEventListener('click', onClose);
        return () => {
            document.removeEventListener('click', onClose);
        };
    }, []);

    const debouncedFetchData = useDebounce((name: string, value: string) => {
        if (value.length > 3) fetchDaData(name, value);
    }, 500);

    const onForm = (name: string, value: string) => {
        onChange(name, value);
        if (value.length === 0) {
            setCompanyList([]);
            return;
        }
        debouncedFetchData(name, value);
    };
    function isNotFound(item: daDataItem | NotFound): item is NotFound {
        return (item as NotFound).isNotFound !== undefined;
    }
    return { companyList, onDaData, onForm, isNotFound };
};
